import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const reissueAsset = (data) => request.post(`${API_BASE_URL}/blockchain/reissue`, data)

export default reissueAsset